module.exports = __webpack_public_path__ + "static/media/dumbbellWrong.9bd693b3.png";